import React, { Component } from "react";
import RelationList from "./relation_list";
import { inject, observer } from "mobx-react";
import { Select, Input } from "antd";
import { AddRelation } from "./";
import { AuthButton, UserSelect } from "@components";
import { toJS } from "mobx";
const { Option } = Select;

@inject("userRelationsStore", "addRelationStore")
@observer
class ShootingTeam extends Component {
  componentDidMount() {
    this.props.userRelationsStore.getUserGroupList();
  }

  get store() {
    return this.props.userRelationsStore;
  }

  handleChange = (value) => {
    this.store.changeShootingTeamTypeActive(value);
  };

  showAdd = () => {
    this.props.addRelationStore.show();
  };

  renderSelect = () => {
    const options = [{id: -1, name: "全部小组"}].concat(this.store.shootingTeamList || [])?.map((item) =>
      item.id ? (
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      ) : (
        ""
      )
    );
    return (
      <Select
        className="select-sz-m"
        size="large"
        placeholder="请选择拍摄小组"
        value={this.store.shootingTeamType}
        onChange={this.handleChange}
        showSearch optionFilterProp="children" showArrow
      >
        {options}
      </Select>
    )
  };

  render() {
    return (
      <div>
        <div className="space-between mg-b-20">
          <div className="display-flex">
            <div className="mg-r-10">
              <span className="mg-r-10">所属拍摄小组</span>
              {this.renderSelect()}
            </div>
            <div className="mg-r-10">
              <span className="mg-r-10">姓名</span>
              <UserSelect
                placeholder="真实姓名"
                className="filter-input mg-r-20"
                value={this.store.shootingTeamUserId}
                onChange={(val) => this.store.changeshootingTeamUserIdActive(val)}
              />
            </div>
          </div>

          <div>
            <AuthButton
              type="primary"
              onClick={this.showAdd}
              permission="relation_create"
            >
              新增
            </AuthButton>
          </div>
        </div>
        <AddRelation />
        <RelationList />
      </div>
    );
  }
}

export default ShootingTeam;
